import { atom } from 'recoil';

export const globalAddress = atom({
  key: 'globalAddress',
  default: undefined,
});
